import styled from "styled-components";

export const StyledDialogBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000099;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledDialog = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  max-width: 420px;
  background-color: #ffffff;
  width: 100%;
  padding: 20px;
  border-radius: 10px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 80%;
    padding: 16px;
  }
`;

export const StyledDialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  svg {
    width: 22px;
    height: 22px;
    cursor: pointer;
    margin-bottom: 20px;
  }
`;

export const StyledDialogTitle = styled.h1`
  font-size: 1.5rem;
  margin: 0;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const StyledDialogBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: center;
  button {
    width: 100%;
    margin-bottom: 10px;
  }
`;
